<template>
  <v-container>
    <v-layout justify-center wrap>
      <v-flex xs12 sm12 md10 lg8>
        <v-layout
          wrap
          class="mt-4"
        >
          <v-select
          v-model="category"
          :items="categories"
          item-text="text"
          item-value="value"
          label="Select a category"
          solo
          class="mr-2"
          ></v-select>
          <v-text-field
            solo
            label="Store ID"
            v-model="store_id"
            @keyup.enter.prevent="search"
          >
            <template v-slot:append-outer>
              <v-btn large color="primary" style="margin-top: -10px" @click="search">Search</v-btn>
            </template>
          </v-text-field>
        </v-layout>
        <v-layout>
          <!-- <v-checkbox
            v-model="sync"
            label="Only include items with Aisle information. (note: number of results will vary with each search)"
          ></v-checkbox> -->
          <v-checkbox
            v-model="profit_positive"
            label="Only show profits that are positive"
          ></v-checkbox>
        </v-layout>
        <v-dialog
          v-model="searching"
          persistent
          width="50%"
        >
          <v-card
            color="primary"
            dark
          >
            <v-card-text>
              <div class="text-center py-3">
                {{count}}
              </div>
              <v-progress-linear
                color="white"
                class="mb-0"
                indeterminate
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12 sm12 md10 lg8 class="d-flex">
        <v-spacer></v-spacer>
        <div class="title my-2">Click Search again to get more results.</div>
      </v-flex>
      <v-flex xs12 sm12 md10 lg8 class="d-flex">
        <v-spacer></v-spacer>
        <v-select
          v-model="sort_by"
          :items="sort_bys"
          label="Sort by"
          solo style="max-width: 160px"
          v-if="processed_items.length && !searching"
        ></v-select>
        <v-select
          v-model="filter_by"
          :items="stock_filters"
          label="Filter by"
          solo class="ml-3" style="max-width: 160px"
          v-if="processed_items.length && !searching"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12 sm12 md10 lg8>
        <MasterProductItem v-for="(item, i) in processed_items" :key="i" :item="item" style="margin-bottom: 2px;"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Search from '../components/Search';
import MasterProductItem from '../components/MasterProductItem';
import request from 'sync-request';

export default {
  components: {
    Search, MasterProductItem
  }, 
  data: () => ({
    searching: false,
    count: 0,
    store_id: '',
    category: '',
    // sync: false,
    profit_positive: false,
    categories: [
      {
        text: 'Toys and Electronics',
        value: 'toy_electronics',
      },
      {
        text: 'Pets',
        value: 'pets',
      },
      {
        text: 'Patio, Sports and Outdoors',
        value: 'patio_sports',
      },
      {
        text: 'Office Supplies and Arts & Crafts',
        value: 'office_art',
      },
      {
        text: 'Health, Bath and Beauty',
        value: 'health_personal_beauty',
      },
      {
        text: 'Food and Snacks',
        value: 'food',
      },
      {
        text: 'Baby',
        value: 'baby'
      },
    ],
    
    product_ids: [],
    items: [],

    stock_filters: [
      'All',
      'In Stock',
      'Out of Stock',
      'Limited Stock',
    ],
    filter_by: '',
    sort_bys: [
      'None',
      'Rank',
      'Profit',
    ],
    sort_by: '',

    product_type: '',
  }),
  computed: {
    processed_items: function(){
      var self = this;
      var unfiltered_resutls = this.items.filter(function(item){
        return self.filter_by === '' || self.filter_by === 'All' || item.status === self.filter_by;
      });
      if(self.sort_by === 'Rank'){
        unfiltered_resutls.sort(function(a, b){
          return parseInt(a.amazon_rank) - parseInt(b.amazon_rank)
        });
      } else if(self.sort_by === 'Profit'){
        unfiltered_resutls.sort(function(a, b){
          return parseFloat(b.profit.replace('$', '')) - parseFloat(a.profit.replace('$', ''))
        })
      }
      return unfiltered_resutls;
    }
  },
  methods: {
    search(){
      this.filter_by = '';
      this.sort_by = '';

      this.items.splice(0, this.product_ids.length)
      this.count = 0;
      this.searching = true;

      var self = this
      axios.post('/search/master-search/init', {
        store_id: this.store_id,
        category: this.category,
        sync: this.sync,
        profit_positive: this.profit_positive
      })
      .then(response =>  {
        this.product_ids = response.data.stores;
        this.product_ids.forEach(element => {
          self.getStore(element)
        });
      }).catch(error => {
        this.searching = false;
      });
    },
    async getStore(product){
      var self = this
      var upc = ("0" + product.upc).slice(-12);
      var url = "https://search.mobile.walmart.com/v1/products-by-code/UPC/" + upc + "?storeId=" + this.store_id;
      await axios.get(url)
      .then(response => { 
        self.count++;
        if(self.count >= self.product_ids.length){
          self.searching = false
        }
        var item_ = Object.assign({}, product)
        if('inventory' in response.data.data.inStore
          && 'status' in response.data.data.inStore.inventory){
          item_.thumbnailImageUrl = response.data.data.common.thumbnailImageUrl;
          if(!item_.thumbnailImageUrl)
            return
          item_.status = response.data.data.inStore.inventory.status;
          if('location' in response.data.data.inStore && 'aisles' in response.data.data.inStore.location)
            item_.aisles = " - Aisle " + response.data.data.inStore.location.aisles[0];
          // else if(self.sync){
          //   return
          //   item_.aisles = '';
          // }
          if('priceInCents' in response.data.data.inStore.price)
            item_.walmart_price = parseFloat(parseInt(response.data.data.inStore.price.priceInCents) / 100);
          else
            item_.walmart_price = parseFloat(parseInt(response.data.data.online.price.priceInCents) / 100);
          if(product.amazon_fees == ''){
            product.amazon_fees = 0
          } else {
            product.amazon_fees = parseFloat(product.amazon_fees.replace('$', ''))
          }
          var profit_val = (parseFloat(product.amazon_price.replace('$', '')) - item_.walmart_price - product.amazon_fees).toFixed(2);
          if(!self.profit_positive || profit_val >= 0){
            item_.profit = '$ ' + profit_val;
            item_.roi = (parseInt(100 * profit_val / item_.walmart_price) + '%');
            self.items.push(item_)
          }
        }
      })
      .catch(error => {
        var self = this
        // console.log(error)
        self.count++;
        if(self.count >= self.product_ids.length){
          self.searching = false;
        }
      })
    },
    async getStoreSync(product){
      let self = this
      self.count++;
      if(self.count >= self.product_ids.length){
        self.searching = false;
      }
      if(this.items.length >= 20){
        self.searching = false;
        return
      }
      var upc = ("0" + product.upc).slice(-12);
      var url = "https://search.mobile.walmart.com/v1/products-by-code/UPC/" + upc + "?storeId=" + this.store_id;
      var res = request('GET', url)
      if(res.statusCode !== 200){
        return
      }
      try{
        var data = JSON.parse(res.getBody()).data
        var item_ = Object.assign({}, product)
        if('aisles' in data.inStore.location)
          item_.aisles = " - Aisle " + data.inStore.location.aisles[0];
        else
          item_.aisles = '';
        if('priceInCents' in data.inStore.price)
          item_.walmart_price = parseFloat(parseInt(data.inStore.price.priceInCents) / 100);
        else
          item_.walmart_price = parseFloat(parseInt(data.online.price.priceInCents) / 100);
        item_.thumbnailImageUrl = data.common.thumbnailImageUrl;
        if(!item_.thumbnailImageUrl)
          return
        item_.status = data.inStore.inventory.status;
        var profit_val = (parseFloat(product.amazon_price.replace('$', '')) - item_.walmart_price - product.amazon_fees).toFixed(2);
        item_.profit = '$ ' + profit_val;
        item_.roi = (parseInt(100 * profit_val / item_.walmart_price) + '%');
        self.items.push(item_)
      }
      catch(err){
        return
      }
    }
  }
};
</script>
